import React from 'react';
import { Player } from '@alien-platform/bo-core';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function BetDetailsTable({ playerData }: { playerData: Player }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Username',
      },
      value: {
        text: playerData.username,
      },
    },
    {
      label: {
        text: 'Email',
      },
      value: {
        text: playerData.profile?.email?.address,
      },
    },
    {
      label: {
        text: 'Telegram',
      },
      value: {
        text: playerData.profile?.telegram?.telegramId,
      },
    },

    {
      label: {
        text: 'Name',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Surname',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Operator',
      },
      value: {
        text: playerData.opTitle,
      },
    },
    {
      label: {
        text: 'Brand',
      },
      value: {
        text: playerData.parentOpId ? playerData.opTitle : '-',
      },
    },
    {
      label: {
        text: 'Tier Level',
      },
      value: {
        text: playerData.tierLevel.currentLevel,
      },
    },
    {
      label: {
        text: 'Affiliated By',
      },
      value: {
        text: playerData.affId,
      },
    },
    {
      label: {
        text: 'Balance',
      },
      value: {
        text: playerData?.wallet?.inUSD?.balance,
      },
    },
  ];

  return <HorizontalTable tableData={tableData} />;
}
